﻿/**
 * @fileOverview re_publicuserlistings_initialiser.js
 *
 * @author May Montazer
 *
 */

define([
    'generalUtilities',
    'navigationControl',
    'notificationsDrawerControl',
    'mixpanelControl',
    'languageControl',
    'profileScrollControl',
    'shareWidgetControl',
    'trackPhoneNumberUtilities'
], function publicUserListingsInitialiser(generalUtilities) {
    'use strict';

    var module;

    module = {};
    module.private = {};

    module.CONTROL_ID = generalUtilities.uuid();

    return module;
});
